export default __webpack_public_path__ + "static/media/glrc-course.cooking-for-holistic-wellness.ea5afc67.png";